import React from 'react';

import { CardContent, Card, Typography } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';

import { LiveChatNotificationResponseNext } from '@alme/types/response/LiveChatNotificationResponse';
import { EntryExtensionData } from '@alme/types/response/EntryExtensionData';

import liveChatUserResponseStyles from './AlmeLiveChatUserResponse.styles';
import { FocusComponentProps } from '../../../../models/ComponentProps';

import { getMaskedUserInput } from '../../../AlmeResponse/AlmeResponseUtils';
import { AlmeLiveChatUserResponseConfig } from './AlmeLiveChatUserResponseConfig';

export function isValidLiveChatUserResponse(response: LiveChatNotificationResponseNext): boolean {
    const maskedUserInput = getMaskedUserInput(response);
    const hasUserInput = !!maskedUserInput;
    return response?.extensionData?.MessageOrigin === 'User' && hasUserInput;
}

interface AlmeLiveChatUserResponseProps extends WithStyles<typeof liveChatUserResponseStyles> {
    response: LiveChatNotificationResponseNext;
    isLastResponse: boolean;
    almeConfig: AlmeLiveChatUserResponseConfig;
    focusProps?: FocusComponentProps;
    responseId?: string | number;
}

const AlmeLiveChatUserResponse: React.FC<AlmeLiveChatUserResponseProps> = (props: AlmeLiveChatUserResponseProps) => {
    if (!isValidLiveChatUserResponse(props.response)) {
        return null;
    }

    const maskedUserInput = getMaskedUserInput(props.response);
    const responseRevision = (props.responseId || props.response.responseRevision).toString();
    const entryId = props.response.id || (props.response.extensionData && (props.response.extensionData as unknown as EntryExtensionData)?.entryId) || responseRevision;

    return (
        <div
            className={props.classes.userCardContainer}
            id={`alme-user-live-chat-card-${responseRevision}`}>
            <Card
                className={props.classes.userCard}
                key={`${entryId}-user`}
                raised={props.isLastResponse}
            >
                <CardContent className={props.classes.userCardContent}>
                    <Typography variant="body1" className={props.classes.userCardBody}>{maskedUserInput}</Typography>
                </CardContent>
            </Card>
            {props.almeConfig.liveChatUserResponse.userIcon}
        </div>
    );
};

export default withStyles(liveChatUserResponseStyles)(AlmeLiveChatUserResponse);
